export const clx = (classNames: (string | undefined | boolean)[]) => {
  return classNames
    .filter(
      (className) => typeof className === "string" && className.length > 0,
    )
    .join(" ")
    .trim();
};
